import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { Label } from '../common/Label';
import { throttle } from 'lodash';
import { connect } from 'react-redux';
import I18n from '../../config/locales';
import { isDRSService } from '../../containers/CreateSystem/helper';

const styles = theme => ({
  labelColor: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontWeight: 400,
    fontSize: theme.spacing(2),
    textTransform: 'initial',
    transform: 'translate(0, -4px) scale(1)'
  }
});

const useLabelStyles = makeStyles(styles);

const AddressField = props => {
  const classes = useLabelStyles();
  const parentClasses = props.classes;
  const { updateAddress = () => { }, error, helperText, value, countryCode } = props;
  const [options, setOptions] = useState([]);
  let autocompleteService = null;
  let geocoder = null;
  if (window.google) {
    autocompleteService = new window.google.maps.places.AutocompleteService();
    geocoder = new window.google.maps.Geocoder();
  }

  const fetchAddress = throttle(request => {
    if (autocompleteService) {
      autocompleteService.getPlacePredictions(request, options => options && setOptions(options));
    }
  }, 200);

  return (
    <Fragment>
      <Autocomplete
        component="span"
        id="street1"
        getOptionLabel={option => (typeof option === 'string' ? option : option.description)}
        filterOptions={x => x}
        options={options}
        freeSolo
        autoComplete
        value={value}
        onChange={(event, newValue) => {
          if (newValue) {
            geocoder.geocode({ placeId: newValue.place_id }, res => {
              if (res[0]) {
                const address = res[0].address_components;
                const zipcode = address.find(comp => comp.types.includes('postal_code'));
                const country = address.find(comp => comp.types.includes('country'));
                const state = address.find(comp => comp.types.includes('administrative_area_level_1'));
                const city = address.find(comp => comp.types.includes('locality'));
                const find = city || state || country;
                let address1 = '';
                address.some(comp => {
                  if (find && find.long_name === comp.long_name) {
                    return true;
                  }
                  address1 += address1 ? `, ${comp.long_name}` : comp.long_name;
                  return null;
                });
                updateAddress({
                  address: res[0].formatted_address,
                  address1,
                  address2: null,
                  country: (country && country.short_name) || null,
                  zipcode: (zipcode && zipcode.long_name) || null,
                  state: (state && state.short_name) || null,
                  city: (city && city.long_name) || null
                });
              }
            });
          } else {
            updateAddress();
          }
        }}
        onInputChange={(event, newInputValue) => {
          if (event && newInputValue) {
            if (isDRSService) {
              const US_AND_TERRITORIES = ['US', 'VI', 'PR', 'AS', 'MP'];
              fetchAddress({
                input: newInputValue,
                componentRestrictions: {
                  country:
                    countryCode && countryCode !== 'US' ? [countryCode] : US_AND_TERRITORIES,
                },
              });
            } else {
              fetchAddress({
                input: newInputValue,
                componentRestrictions: {
                  country: countryCode ? countryCode : 'US',
                },
              });
            }
            updateAddress(newInputValue);
          }
        }}
        renderInput={params => (
          <TextField
            {...params}
            error={error}
            helperText={error && helperText}
            id="address_error"
            className={parentClasses ? parentClasses.inputField : null}
            label={<Label keyValue="address" className={classes.labelColor} text={I18n.t('createSystem.address')} isRequired />}
          />
        )}
        renderOption={option => (
          <Grid container alignItems="center">
            <Grid item>
              <LocationOnIcon className={classes.icon} />
            </Grid>
            <Grid item xs>
              <Typography variant="body1" color="textPrimary">
                {option.structured_formatting ? option.structured_formatting.main_text : ''}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {option.structured_formatting ? option.structured_formatting.secondary_text : ''}
              </Typography>
            </Grid>
          </Grid>
        )}
        className={classes.searchArea}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  countryCode: state.defaultReducer.country
})

export default connect(mapStateToProps, null)(AddressField);

